/**
 * Background Playground - Temporary experimentation tool
 *
 * Usage: Add to index.html: <script src="/ui/wip/bg-playground.js"></script>
 * Then in console: bgPlay.try(0), bgPlay.cycle(), etc.
 */

window.bgPlay = {
  // Apply background to all relevant elements
  _apply: function(css) {
    // Set on body
    document.body.style.background = css;
    document.body.style.backgroundAttachment = 'fixed';

    // Also set CSS variable for elements using var(--bg)
    document.documentElement.style.setProperty('--main-bg', css);

    // Hide orbs if they're covering the background
    var orbs = document.querySelectorAll('.orb');
    orbs.forEach(function(o) { o.style.opacity = '0'; });

    // Hide grid if present
    var grid = document.querySelector('.grid-bg');
    if (grid) grid.style.opacity = '0';
  },

  // Quick setters
  solid: function(color) {
    document.documentElement.style.setProperty('--bg', color);
    document.documentElement.style.setProperty('--bg-alt', color);
    this._apply(color);
  },

  gradient: function(css) {
    this._apply(css);
  },

  // Reset to theme default
  reset: function() {
    document.body.style.background = '';
    document.body.style.backgroundAttachment = '';
    document.body.style.backgroundImage = '';
    document.body.style.backgroundSize = '';
    document.body.style.backgroundPosition = '';
    document.body.style.backgroundRepeat = '';
    document.documentElement.style.removeProperty('--main-bg');

    // Restore orbs
    var orbs = document.querySelectorAll('.orb');
    orbs.forEach(function(o) { o.style.opacity = ''; });

    // Restore grid
    var grid = document.querySelector('.grid-bg');
    if (grid) grid.style.opacity = '';

    // Note: Don't call ThemeSystem.applyAll() here - it causes infinite loop
    // when switching background styles. The CSS handles visibility via data-bg-style.
  },

  // Presets - use bgPlay.try(0) through bgPlay.try(15)
  presets: [
    // LIGHT THEMES
    // 0: Nordic aurora
    'linear-gradient(135deg, #e8f4f8 0%, #d4e5ed 25%, #f0e6f6 50%, #fce4ec 75%, #fff8e1 100%)',
    // 1: Soft lavender
    'linear-gradient(145deg, #f5f3ff 0%, #ede9fe 50%, #fdf4ff 100%)',
    // 2: Ocean mist
    'linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 40%, #f0fdfa 100%)',
    // 3: Warm sunset
    'linear-gradient(135deg, #fef3c7 0%, #fce7f3 50%, #f5f3ff 100%)',
    // 4: Cool mint
    'linear-gradient(160deg, #ecfdf5 0%, #f0fdfa 50%, #f0f9ff 100%)',
    // 5: Peach dream
    'linear-gradient(135deg, #fff7ed 0%, #fef2f2 50%, #fdf4ff 100%)',
    // 6: Nordic frost (radial)
    'radial-gradient(ellipse at top left, #dbeafe 0%, transparent 50%), radial-gradient(ellipse at bottom right, #fae8ff 0%, transparent 50%), #f8fafc',
    // 7: Mesh gradient light
    'radial-gradient(at 40% 20%, #fdf4ff 0px, transparent 50%), radial-gradient(at 80% 0%, #dbeafe 0px, transparent 50%), radial-gradient(at 0% 50%, #fef3c7 0px, transparent 50%), radial-gradient(at 80% 50%, #dcfce7 0px, transparent 50%), radial-gradient(at 0% 100%, #fce7f3 0px, transparent 50%), #ffffff',
    // 8: Glass morphism base
    'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(240,240,255,0.9) 100%)',
    // 9: Soft rainbow
    'linear-gradient(90deg, #fff5f5 0%, #fffaf0 20%, #f0fff4 40%, #f0f9ff 60%, #faf5ff 80%, #fff5f7 100%)',

    // DARK THEMES
    // 10: Dark nordic
    'linear-gradient(135deg, #1e293b 0%, #334155 50%, #1e1b4b 100%)',
    // 11: Dark aurora
    'radial-gradient(ellipse at top, #312e81 0%, transparent 50%), radial-gradient(ellipse at bottom, #064e3b 0%, transparent 50%), #0f172a',
    // 12: Cyberpunk
    'linear-gradient(135deg, #0f0f23 0%, #1a1a3e 50%, #2d1b4e 100%)',
    // 13: Deep ocean
    'linear-gradient(180deg, #0c1929 0%, #1e3a5f 50%, #0f172a 100%)',
    // 14: Sunset dark
    'linear-gradient(135deg, #1f1215 0%, #2d1f3d 50%, #1a1a2e 100%)',
    // 15: Tokyo night
    'linear-gradient(135deg, #1a1b26 0%, #24283b 50%, #1a1b26 100%)'
  ],

  // Try a preset by number
  try: function(n) {
    if (n >= 0 && n < this.presets.length) {
      this._apply(this.presets[n]);
      console.log('Applied preset ' + n + ': ' + this.presets[n].substring(0, 50) + '...');
    } else {
      console.log('Preset ' + n + ' not found. Use 0-' + (this.presets.length - 1));
    }
  },

  // Cycle through all presets
  _cycleId: null,
  cycle: function(delay) {
    var self = this;
    var i = 0;
    delay = delay || 2000;

    this._cycleId = setInterval(function() {
      self.try(i);
      i = (i + 1) % self.presets.length;
    }, delay);

    console.log('Cycling presets every ' + delay + 'ms. Use bgPlay.stop() to stop.');
  },

  stop: function() {
    if (this._cycleId) {
      clearInterval(this._cycleId);
      this._cycleId = null;
      console.log('Stopped cycling.');
    }
  },

  // Build custom gradient from array of colors
  make: function(colors, angle) {
    angle = angle || 135;
    var stops = colors.map(function(c, i) {
      return c + ' ' + Math.round(i / (colors.length - 1) * 100) + '%';
    }).join(', ');
    var css = 'linear-gradient(' + angle + 'deg, ' + stops + ')';
    document.body.style.background = css;
    console.log('Applied: ' + css);
    return css;
  },

  // Radial gradient helper
  radial: function(colors, position) {
    position = position || 'center';
    var stops = colors.map(function(c, i) {
      return c + ' ' + Math.round(i / (colors.length - 1) * 100) + '%';
    }).join(', ');
    var css = 'radial-gradient(ellipse at ' + position + ', ' + stops + ')';
    document.body.style.background = css;
    console.log('Applied: ' + css);
    return css;
  },

  // Random preset
  random: function() {
    var n = Math.floor(Math.random() * this.presets.length);
    this.try(n);
    return n;
  },

  // SVG patterns (inline data URIs for subtle backgrounds)
  svgPatterns: [
    // 0: Subtle dots
    'url("data:image/svg+xml,%3Csvg width=\'20\' height=\'20\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Ccircle cx=\'2\' cy=\'2\' r=\'1\' fill=\'%23000\' fill-opacity=\'0.05\'/%3E%3C/svg%3E")',
    // 1: Grid lines
    'url("data:image/svg+xml,%3Csvg width=\'40\' height=\'40\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M0 0h40v40H0z\' fill=\'none\' stroke=\'%23000\' stroke-opacity=\'0.03\'/%3E%3C/svg%3E")',
    // 2: Diagonal lines
    'url("data:image/svg+xml,%3Csvg width=\'10\' height=\'10\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M0 10L10 0\' stroke=\'%23000\' stroke-opacity=\'0.03\'/%3E%3C/svg%3E")',
    // 3: Hexagons
    'url("data:image/svg+xml,%3Csvg width=\'28\' height=\'49\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M14 0l14 8v16l-14 8L0 24V8z\' fill=\'none\' stroke=\'%23000\' stroke-opacity=\'0.04\'/%3E%3C/svg%3E")',
    // 4: Circles
    'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Ccircle cx=\'30\' cy=\'30\' r=\'20\' fill=\'none\' stroke=\'%23000\' stroke-opacity=\'0.03\'/%3E%3C/svg%3E")',
    // 5: Topography
    'url("data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M0 50c20-20 30 20 50 0s30 20 50 0\' fill=\'none\' stroke=\'%239ca3af\' stroke-opacity=\'0.15\'/%3E%3Cpath d=\'M0 70c20-20 30 20 50 0s30 20 50 0\' fill=\'none\' stroke=\'%239ca3af\' stroke-opacity=\'0.1\'/%3E%3C/svg%3E")',
    // 6: Plus signs
    'url("data:image/svg+xml,%3Csvg width=\'24\' height=\'24\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M12 4v16M4 12h16\' stroke=\'%23000\' stroke-opacity=\'0.04\' stroke-width=\'1\'/%3E%3C/svg%3E")',
    // 7: Waves
    'url("data:image/svg+xml,%3Csvg width=\'100\' height=\'20\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M0 10c25-10 25 10 50 0s25 10 50 0\' fill=\'none\' stroke=\'%236366f1\' stroke-opacity=\'0.08\'/%3E%3C/svg%3E")'
  ],

  // Apply SVG pattern over a base color
  svg: function(patternIndex, baseColor) {
    baseColor = baseColor || '#f8fafc';
    var pattern = this.svgPatterns[patternIndex] || this.svgPatterns[0];
    this._apply(baseColor);
    document.body.style.backgroundImage = pattern;
    console.log('Applied SVG pattern ' + patternIndex + ' over ' + baseColor);
  },

  // Combine gradient + SVG pattern
  combo: function(gradientIndex, svgIndex) {
    var gradient = this.presets[gradientIndex] || this.presets[0];
    var pattern = this.svgPatterns[svgIndex] || this.svgPatterns[0];
    this._apply(gradient);
    document.body.style.backgroundImage = pattern + ', ' + gradient;
    console.log('Combined gradient ' + gradientIndex + ' with SVG ' + svgIndex);
  },

  // Layered waves generator (theme-driven)
  // style: 'bottom-third' (default), 'large', 'small', 'scattered', 'full', 'hills', 'angular'
  waves: function(position, intensity, style) {
    position = position || 'bottom'; // 'bottom', 'top'
    intensity = intensity || 0.6; // 0-1, how prominent the waves are
    style = style || 'bottom-third';

    // Get wave colors from CSS variables (theme-driven)
    var root = getComputedStyle(document.documentElement);
    var bg = root.getPropertyValue('--bg').trim() || '#ffffff';

    // Read wave colors from CSS - these are derived from theme colors via color-mix
    // Must resolve color-mix() values using temp element since getComputedStyle returns raw strings
    var self = this;
    var waveColors = [
      self._resolveCssColor(root.getPropertyValue('--wave-1')),
      self._resolveCssColor(root.getPropertyValue('--wave-2')),
      self._resolveCssColor(root.getPropertyValue('--wave-3')),
      self._resolveCssColor(root.getPropertyValue('--wave-4')),
      self._resolveCssColor(root.getPropertyValue('--wave-5'))
    ].filter(function(c) { return c; }); // Remove empty/null values

    // Fallback if CSS variables not defined
    if (waveColors.length < 5) {
      var accent = root.getPropertyValue('--accent').trim() || '#3b82f6';
      var accentBright = root.getPropertyValue('--accent-bright').trim() || '#60a5fa';
      var bgAlt = root.getPropertyValue('--bg-alt').trim() || '#f8fafc';
      waveColors = [
        this._mixColor(bg, accent, 0.5),
        this._mixColor(bg, accentBright, 0.6),
        this._mixColor(bg, accent, 0.45),
        this._mixColor(bgAlt, accent, 0.65),
        this._mixColor(bg, accentBright, 0.55)
      ];
    }

    var svg = this._generateWavesSVG(waveColors, position, intensity, style);
    var encoded = 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';

    this._apply(bg);
    document.body.style.backgroundImage = encoded;
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundPosition = position === 'top' ? 'top' : 'bottom';
    document.body.style.backgroundRepeat = 'no-repeat';

    console.log('Applied theme-driven waves (' + position + ', ' + style + ')');
  },

  // Generate the waves SVG with variety
  _generateWavesSVG: function(colors, position, intensity, style) {
    style = style || 'bottom-third'; // 'bottom-third', 'full', 'large', 'small', 'scattered'
    var flip = position === 'top' ? ' transform="scale(1,-1) translate(0,-512)"' : '';

    var pathSets = {
      // Original: waves in bottom third
      'bottom-third': [
        'M0,320 C150,280 350,360 500,320 C650,280 800,340 960,300 L960,512 L0,512 Z',
        'M0,360 C120,330 280,400 440,360 C600,320 780,380 960,350 L960,512 L0,512 Z',
        'M0,400 C200,370 300,430 480,400 C660,370 800,420 960,390 L960,512 L0,512 Z',
        'M0,440 C160,420 320,470 500,440 C680,410 840,450 960,430 L960,512 L0,512 Z',
        'M0,470 C180,455 360,490 540,470 C720,450 880,480 960,465 L960,512 L0,512 Z'
      ],
      // Large dramatic waves spanning most of the screen
      'large': [
        'M0,100 C200,50 400,200 500,100 C600,0 750,150 960,80 L960,512 L0,512 Z',
        'M0,180 C150,120 350,250 480,180 C610,110 800,220 960,160 L960,512 L0,512 Z',
        'M0,280 C180,220 380,340 520,280 C660,220 820,320 960,260 L960,512 L0,512 Z',
        'M0,380 C160,340 340,420 500,380 C660,340 820,400 960,360 L960,512 L0,512 Z',
        'M0,460 C200,440 400,480 600,460 C800,440 900,470 960,455 L960,512 L0,512 Z'
      ],
      // Small subtle waves at very bottom
      'small': [
        'M0,480 C80,475 160,490 240,480 C320,470 400,485 480,480 C560,475 640,490 720,480 C800,470 880,485 960,478 L960,512 L0,512 Z',
        'M0,490 C100,485 200,498 300,490 C400,482 500,495 600,490 C700,485 800,495 960,488 L960,512 L0,512 Z',
        'M0,498 C120,495 240,502 360,498 C480,494 600,502 720,498 C840,494 960,500 960,498 L960,512 L0,512 Z'
      ],
      // Scattered waves at different heights
      'scattered': [
        'M0,80 C100,60 180,100 280,80 C380,60 480,95 580,75 L580,150 C480,170 380,135 280,155 C180,175 100,140 0,160 Z',
        'M380,200 C480,180 580,220 680,200 C780,180 880,215 960,195 L960,280 C880,300 780,265 680,285 C580,305 480,270 380,290 Z',
        'M0,350 C150,320 300,380 450,350 C600,320 750,370 960,340 L960,512 L0,512 Z',
        'M0,420 C200,400 400,450 600,420 C800,390 900,430 960,410 L960,512 L0,512 Z',
        'M0,470 C180,455 360,490 540,470 C720,450 880,480 960,465 L960,512 L0,512 Z'
      ],
      // Full height waves from top to bottom
      'full': [
        'M0,50 C240,0 480,100 720,50 C840,25 960,70 960,50 L960,512 L0,512 Z',
        'M0,150 C160,100 320,200 480,150 C640,100 800,180 960,130 L960,512 L0,512 Z',
        'M0,280 C200,230 400,330 600,280 C800,230 900,300 960,260 L960,512 L0,512 Z',
        'M0,400 C180,360 360,440 540,400 C720,360 880,420 960,380 L960,512 L0,512 Z',
        'M0,480 C200,465 400,495 600,480 C800,465 900,490 960,475 L960,512 L0,512 Z'
      ],
      // Gentle rolling hills
      'hills': [
        'M0,200 C320,100 640,300 960,200 L960,512 L0,512 Z',
        'M0,320 C240,260 480,380 720,320 C840,290 960,340 960,320 L960,512 L0,512 Z',
        'M0,420 C200,380 400,460 600,420 C800,380 960,440 960,420 L960,512 L0,512 Z'
      ],
      // Sharp angular waves
      'angular': [
        'M0,150 L160,80 L320,180 L480,60 L640,160 L800,100 L960,200 L960,512 L0,512 Z',
        'M0,280 L120,220 L280,300 L440,200 L600,320 L760,240 L960,340 L960,512 L0,512 Z',
        'M0,400 L200,360 L400,420 L600,350 L800,430 L960,380 L960,512 L0,512 Z',
        'M0,480 L240,460 L480,490 L720,455 L960,475 L960,512 L0,512 Z'
      ]
    };

    var paths = pathSets[style] || pathSets['bottom-third'];

    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 960 512" preserveAspectRatio="none"' + flip + '>';

    for (var i = 0; i < Math.min(colors.length, paths.length); i++) {
      // Full opacity for more visible waves
      svg += '<path d="' + paths[i] + '" fill="' + colors[i] + '"/>';
    }

    svg += '</svg>';
    return svg;
  },

  // Check if color is dark
  _isDark: function(color) {
    var hex = color.replace('#', '');
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    var r = parseInt(hex.substr(0, 2), 16);
    var g = parseInt(hex.substr(2, 2), 16);
    var b = parseInt(hex.substr(4, 2), 16);
    var luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance < 0.5;
  },

  // Mix two colors
  _mixColor: function(color1, color2, amount) {
    var c1 = this._hexToRgb(color1);
    var c2 = this._hexToRgb(color2);
    if (!c1 || !c2) return color1;

    var r = Math.round(c1.r + (c2.r - c1.r) * amount);
    var g = Math.round(c1.g + (c2.g - c1.g) * amount);
    var b = Math.round(c1.b + (c2.b - c1.b) * amount);

    return 'rgb(' + r + ',' + g + ',' + b + ')';
  },

  _hexToRgb: function(color) {
    // Handle rgb() format
    if (color.startsWith('rgb')) {
      var match = color.match(/(\d+)/g);
      if (match) return { r: parseInt(match[0]), g: parseInt(match[1]), b: parseInt(match[2]) };
    }
    // Handle hex
    var hex = color.replace('#', '');
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    var result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  },

  // Resolve a CSS color value (including color-mix()) to a computed hex/rgb value
  _resolveCssColor: function(cssValue) {
    if (!cssValue || !cssValue.trim()) return null;
    cssValue = cssValue.trim();

    // If it's already a simple color (hex or rgb), return it
    if (cssValue.startsWith('#') || cssValue.startsWith('rgb')) {
      return cssValue;
    }

    // For color-mix() and other CSS functions, use a temp element to resolve
    var temp = document.createElement('div');
    temp.style.display = 'none';
    temp.style.color = cssValue;
    document.body.appendChild(temp);
    var computed = getComputedStyle(temp).color;
    document.body.removeChild(temp);

    return computed || null;
  },

  // Preset wave styles (ordered smallest to largest)
  wavesPresets: [
    // 0: Subtle - minimal waves at bottom edge
    { position: 'bottom', intensity: 0.6, style: 'small' },
    // 1: Gentle - waves in bottom third
    { position: 'bottom', intensity: 0.5, style: 'bottom-third' },
    // 2: Rolling - hill-like waves
    { position: 'bottom', intensity: 0.8, style: 'hills' },
    // 3: Bold - dramatic waves spanning most of screen
    { position: 'bottom', intensity: 0.8, style: 'large' },
    // 4: Full - full height waves
    { position: 'bottom', intensity: 0.7, style: 'full' },
    // 5: Angular/sharp waves
    { position: 'bottom', intensity: 0.7, style: 'angular' },
    // 6: Scattered floating waves
    { position: 'bottom', intensity: 0.6, style: 'scattered' },
    // 7: Top waves
    { position: 'top', intensity: 0.6, style: 'bottom-third' },
    // 8: Top large waves
    { position: 'top', intensity: 0.7, style: 'large' }
  ],

  // Quick wave preset
  wave: function(n) {
    var preset = this.wavesPresets[n] || this.wavesPresets[0];
    this.waves(preset.position, preset.intensity, preset.style);
  },

  // Grid background (theme-driven SVG pattern)
  // size: grid cell size in pixels (20-100, default 50)
  grid: function(size) {
    size = size || 50;

    // Get colors from CSS variables (theme-driven)
    var root = getComputedStyle(document.documentElement);
    var bg = this._resolveCssColor(root.getPropertyValue('--bg')) || '#f8fafc';
    var text = this._resolveCssColor(root.getPropertyValue('--text')) || '#333';

    // Determine grid line color based on theme brightness
    var isDark = this._isDark(bg);
    var lineColor = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)';

    // Generate SVG grid pattern
    var svg = this._generateGridSVG(size, lineColor);
    var encoded = 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';

    this._apply(bg);
    document.body.style.backgroundImage = encoded;
    document.body.style.backgroundSize = size + 'px ' + size + 'px';
    document.body.style.backgroundPosition = '0 0';
    document.body.style.backgroundRepeat = 'repeat';

    console.log('Applied grid background (' + size + 'px)');
  },

  // Generate grid SVG
  _generateGridSVG: function(size, lineColor) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '">' +
      '<path d="M ' + size + ' 0 L 0 0 0 ' + size + '" fill="none" stroke="' + lineColor + '" stroke-width="1"/>' +
      '</svg>';
  },

  // Beautiful abstract patterns from external sources (optional)
  urls: [
    // 0: Subtle geometric (SVGBackgrounds.com style)
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    // 1: Blob mesh
    'url("https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=1920&q=80")',
    // 2: Gradient mesh abstract
    'url("https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=1920&q=80")',
    // 3: Soft pastel abstract
    'url("https://images.unsplash.com/photo-1557683316-973673bdar25?w=1920&q=80")'
  ],

  // Try external URL background
  url: function(n) {
    var bg = this.urls[n] || this.urls[0];
    document.body.style.background = bg;
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundPosition = 'center';
    console.log('Applied URL background ' + n);
  },

  // Show help
  help: function() {
    console.log([
      '',
      '🎨 Background Playground',
      '========================',
      '',
      'Presets (0-15):',
      '  bgPlay.try(0)    - Nordic aurora (light)',
      '  bgPlay.try(7)    - Mesh gradient (light)',
      '  bgPlay.try(10)   - Dark nordic',
      '  bgPlay.try(11)   - Dark aurora',
      '  bgPlay.random()  - Random preset',
      '',
      'SVG Patterns (0-7):',
      '  bgPlay.svg(0)              - Dots on default bg',
      '  bgPlay.svg(1, "#f0f9ff")   - Grid on custom color',
      '  bgPlay.svg(5)              - Topography lines',
      '  bgPlay.svg(7)              - Waves',
      '',
      'Combos (gradient + pattern):',
      '  bgPlay.combo(0, 0)  - Aurora + dots',
      '  bgPlay.combo(7, 5)  - Mesh + topography',
      '',
      'Theme-Driven Waves:',
      '  bgPlay.waves()                        - Bottom waves (uses theme colors)',
      '  bgPlay.waves("bottom", 0.6, "large")  - Large dramatic waves',
      '  bgPlay.waves("bottom", 0.6, "small")  - Subtle small waves',
      '  bgPlay.waves("bottom", 0.7, "full")   - Full height waves',
      '  bgPlay.waves("bottom", 0.8, "hills")  - Rolling hills',
      '  bgPlay.waves("bottom", 0.7, "angular")- Sharp angular waves',
      '  bgPlay.waves("bottom", 0.6, "scattered") - Floating scattered',
      '',
      'Wave Presets (0-8):',
      '  bgPlay.wave(0) - Gentle bottom     bgPlay.wave(1) - Large dramatic',
      '  bgPlay.wave(2) - Small subtle      bgPlay.wave(3) - Full height',
      '  bgPlay.wave(4) - Rolling hills     bgPlay.wave(5) - Angular/sharp',
      '  bgPlay.wave(6) - Scattered         bgPlay.wave(7) - Top waves',
      '  bgPlay.wave(8) - Top large',
      '',
      'Cycling:',
      '  bgPlay.cycle()      - Auto-cycle all (2s)',
      '  bgPlay.cycle(1000)  - Cycle every 1s',
      '  bgPlay.stop()       - Stop cycling',
      '',
      'Custom:',
      '  bgPlay.solid("#f5f3ff")',
      '  bgPlay.gradient("linear-gradient(135deg, #fff, #f0f)")',
      '  bgPlay.make(["#fdf4ff", "#dbeafe", "#dcfce7"])',
      '  bgPlay.radial(["#fff", "#ddd"], "top")',
      '',
      'Reset:',
      '  bgPlay.reset()  - Restore theme default',
      ''
    ].join('\n'));
  }
};

// Auto-show help on load
if (window.Debug) window.Debug.log('ui', '🎨 bgPlay loaded! Type bgPlay.help() for commands, or bgPlay.try(0) to start.');
